var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.6875,
    height: 20,
    rx: 3.72308,
    fill: "#FF510D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4437 8.51923C16.9382 8.51923 17.3745 8.95553 17.3745 9.45V10.3808C17.3745 10.9043 16.9382 11.3115 16.4437 11.3115H12.2553V15.5C12.2553 16.0236 11.819 16.4308 11.3245 16.4308H10.3937C9.87019 16.4308 9.46298 16.0236 9.46298 15.5V11.3115H5.27452C4.75096 11.3115 4.34375 10.9043 4.34375 10.3808V9.45C4.34375 8.95553 4.75096 8.51923 5.27452 8.51923H9.46298V4.33077C9.46298 3.8363 9.87019 3.4 10.3937 3.4H11.3245C11.819 3.4 12.2553 3.8363 12.2553 4.33077V8.51923H16.4437Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.9a110aae4e21f1b39420ef4cd337a9d8.svg";
export { ForwardRef as ReactComponent };